import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const fetchClientes = async ({
  search = "",
  search_mun = "",
  search_ite = "",
  page = "",
  pageSize = 1000,
  token,
  username,
  password
}) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";
  const apiUrl = `${baseUrl}api/v1/clientes`;

  try {
    const response = await workflowAxiosGet(
      apiUrl,
      {
        params: {
          empresa: "01",
          filial: "01",
          search: search,
          search_mun: search_mun,
          search_ite: search_ite,
          page: page,
          pagesize: pageSize
        }
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar clientes:", error);
    throw error;
  }
};

export default fetchClientes;
